// extracted by mini-css-extract-plugin
export default {"wrapper":"fZ-z","availablePromoMessagesLabel":"gZ-z","promoMessageList":"hZ-z","promoMessage":"iZ-z","appliedPromoMessage":"jZ-z","promoMessageAmount":"kZ-z"};